import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react"
export type KontoMetaDataInfo = {
  readonly hjelpetekst?: string
  readonly advarsel?: string
  readonly eksempler?: string
  readonly gyldigeMvakoder: string[]
  readonly defaultMvakode: string
  readonly defaultMvakodeErIngen: boolean
  readonly labels: string[]
  readonly statusfarge?: string
  readonly sokeord: string[]
  readonly hjelpetekstForFuse?: string
  readonly sokeordForFuse: string
  readonly fulltekstForFilter: string
}

export type KontoInfo = {
  readonly kontonummer: number
  readonly navn: string
  readonly kunForOrgForm: string[]
  readonly metaData: KontoMetaDataInfo
}

export type KontogruppeInfo = {
  readonly navn: string
  readonly nummer: number
  readonly kontoer: KontoInfo[]
  readonly sokeord: string[]
}

const { DEV } = import.meta.env
const baseUrl: string = DEV ? "/base" : ""

export const transformKontogrupper = (returnValue: KontogruppeInfo[]): KontogruppeInfo[] => {
  return returnValue.map(({ kontoer, ...gruppeProps }) => {
    const sokeord: string[] = []
    const konto: KontoInfo[] = kontoer.map(({ metaData, ...props }) => {
      const sokeordForFuse = `${metaData.sokeord.join(" ")} ${props.navn.toLowerCase()}`
      const fulltekstForFilter = [
        props.kontonummer,
        props.navn,
        ...props.kunForOrgForm,
        ...metaData.sokeord,
        ...metaData.labels,
        ...metaData.gyldigeMvakoder,
        metaData.defaultMvakode,
        metaData.hjelpetekst,
        metaData.advarsel,
        metaData.eksempler,
      ]
        .filter((del) => del !== undefined)
        .join(" ")
        .toLowerCase()
      metaData.sokeord.forEach((ord) => {
        if (!sokeord.includes(ord)) {
          sokeord.push(ord)
        }
      })
      return {
        ...props,
        metaData: {
          ...metaData,
          hjelpetekstForFuse: metaData.hjelpetekst?.replace(/\[(.*)]\(.*\)/, "$1"),
          sokeordForFuse,
          fulltekstForFilter,
        },
      }
    })
    return { ...gruppeProps, kontoer: konto, sokeord }
  })
}

export const apiSlice = createApi({
  reducerPath: "api",

  baseQuery: fetchBaseQuery({
    baseUrl: `${baseUrl}/data`,
  }),
  tagTypes: ["KontoGruppeInfo"],
  endpoints: (build) => ({
    fetchKontogrupper: build.query<KontogruppeInfo[], void>({
      query: () => "/kontoGruppeInfo",
      providesTags: () => ["KontoGruppeInfo"],
      transformResponse: transformKontogrupper,
    }),
  }),
})

export const { useFetchKontogrupperQuery } = apiSlice
